var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81003 9.85715C5.81003 9.05125 5.9717 8.25332 6.28574 7.50935C6.59977 6.76539 7.05995 6.09009 7.63976 5.5224C8.21956 4.95471 8.90752 4.50585 9.66397 4.20168C10.4204 3.89752 11.2304 3.74407 12.0473 3.75018C15.4605 3.77514 18.1907 6.56636 18.1907 9.93381V11.2143C18.1907 14.2522 18.8367 16.0151 19.4057 16.9786C19.4669 17.0817 19.4994 17.1988 19.5 17.3183C19.5006 17.4377 19.4692 17.5552 19.409 17.6589C19.3488 17.7625 19.2619 17.8486 19.1571 17.9085C19.0524 17.9684 18.9335 18 18.8124 18H5.18761C5.06652 18 4.94758 17.9684 4.84282 17.9085C4.73805 17.8486 4.65118 17.7624 4.59099 17.6588C4.5308 17.5551 4.49941 17.4376 4.50001 17.3182C4.50061 17.1987 4.53316 17.0815 4.59439 16.9784C5.16369 16.0149 5.81003 14.2521 5.81003 11.2143V9.85715Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSimple);
export default __webpack_public_path__ + "static/media/BellSimple.0eb90ed2421c274c42d4c697d5272e68.svg";
export { ForwardRef as ReactComponent };